import * as types from './mutation-types'

const mutations = {
  [types.SET_CONTACT_INDEX](state, index) {
    state.contactIndex = index
  },
  [types.SET_STEP_INDEX](state, index) {
    state.stepIndex = index
  },
  [types.GET_MERCHAT_INFO](state, info) {
    state.merchantInfo = { ...state.merchantInfo, ...info }
  },
  [types.SET_APPLY_STATUS](state, bool) {
    state.applyStatus = bool
  },
  [types.LOGIN_STATUS](state, bool) {
    state.loginStatus = bool
  },
  [types.GET_ADDRESS_INFO](state, info) {
    state.addressInfo = info
  },
  [types.GET_BRAND_INFO](state, info) {
    state.brandInfo = info
  },
  [types.SET_ISADMIN](state, bool) {
    state.isAdmin = bool
  },
  [types.SET_ISTATIONED](state, bool) {
    state.isStaioned = bool
  },
  [types.SET_ISOVERSEAS](state, bool) {
    state.isOverseas = bool
  },
  [types.SET_ENTER_STATE](state, value) {
    state.enterState = value
  },
  [types.SET_SIGN_STATE](state, value) {
    state.signState = value
  },
  [types.SET_SIGN_DATA](state, data) {
    state.signData = data
  },
  [types.SET_OPERATION_LOG](state, data) {
    state.operationLog = data
  },
  [types.SET_MERCHANT_DATA](state, data) {
    state.merchantData = data
  },
  [types.SET_REVIEW_DURATION](state, hours) {
    state.reviewDuration = hours
  },
  [types.SET_APPLICATION_ID](state, id) {
    state.applicationId = id
  }
}

export default mutations
